import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useInputChange } from '../../helpers/useInputChange'

const ChangePasswordPage = (props) => {

  var cognitoUser = window.userPool.getCurrentUser()

  const [email, setEmail] = useState()
  const [oldPassword, setOldPassword] = useInputChange()
  const [newPassword, setNewPassword] = useInputChange()
  const [error, setError] = useState()

  if (cognitoUser != null) {
    if (!email) {
      cognitoUser.getSession(function (err, session) {
        cognitoUser.getUserAttributes(function (err, result) {
          const emailAttribute = result.find(a => a.Name === "email")
          setEmail(emailAttribute.Value)
        })
      })
    }
  }

  const history = useHistory();
  const { t } = useTranslation()

  const onSubmit = (e) => {
    e.preventDefault();

    if (newPassword && oldPassword === newPassword) {
      setError(t("changepassword_different"))
      return
    }

    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true
    cognitoUser.getSession(function (err, session) {
      //TODO: Can we cache that?
      // NOTE: getSession must be called to authenticate user before calling getUserAttributes
      cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
        if (err) {
          button.clicked = false
          setError(err.message)
          return;
        } else {
          history.push("/user/profile")
        }
      });
    });
  }

  document.title = t("titleappname") + t("btn_change_password")

  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("btn_change_password")}</h3>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="form-control"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_email")}
          value={email}
          disabled={true} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_old_password")}</span>
        <input className="form-control"
          type="password"
          name="old-password"
          autoComplete="old-password"
          id="old-password"
          placeholder="Type your password"
          onChange={setOldPassword}
          minLength="6"
          required={true} />
        <span className="focus-input100" data-symbol="&#xf023;"></span>
      </div>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_new_password")}</span>
        <input className="form-control"
          type="password"
          name="new-password"
          id="new-password"
          placeholder="Type your password"
          onChange={setNewPassword}
          required={true}
          minLength="6"
          pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,99}"
          title={t("val_password")} />
        <span className="focus-input100" data-symbol="&#xf023;"></span>
      </div>
      <br />
      {error ? <small id="errorMessage" className="text-danger">{error}<br /></small> : ""}
      <br />
      <div>
        <input type="submit" className="submit-btn" value={t("btn_changepassword_submit")} />
      </div>
    </form>
  </div>
}

export default ChangePasswordPage